export enum ShareOwnership {
  All = 0,
  Both = 1,
  Direct = 2,
  Nominee = 3,
}
